import {FETCH_ASSET_BEGIN,FETCH_ASSET_SUCCESS,FETCH_ASSET_FAILURE, FETCH_ASSET_CURRENCYTYPE_BEGIN, FETCH_ASSET_CURRENCYTYPE_SUCCESS, FETCH_ASSET_CURRENCYTYPE_FAILURE} from '../constants/assets';

const initialState={
    asset:{},
    assetCurrency:{},
    isLoading:false,
    errorcode:"200",
    error:""

}


export const getAssetReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSET_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSET_FAILURE:

        return {
            ...state,
            isLoading:false,
            asset:null,
            errorcode:payload.errorcode

         };
     case FETCH_ASSET_SUCCESS:
         return {
             ...state,
             asset: payload.assetDataItem,
             isLoading: true,
         };
     case FETCH_ASSET_CURRENCYTYPE_BEGIN:
         return {
             ...state,
             assetCurrency: {}
         };
     case FETCH_ASSET_CURRENCYTYPE_SUCCESS:
         return {
             ...state,
             assetCurrency: payload.currencyType
         };
     case FETCH_ASSET_CURRENCYTYPE_FAILURE:
         return {
             ...state,
             assetCurrency: {}
         };
    default:
        return state;
 }
}

export default getAssetReducer
